import React from 'react';
import { Headline } from '@folio/stripes/components';
import { Pluggable } from '@folio/stripes/core';
import { FormattedMessage } from 'react-intl';
import css from './MissingAllEntityTypePermissionsPage.module.css';
export function MissingAllEntityTypePermissionsPage() {
    return (React.createElement(Pluggable, { type: "frontpage" },
        React.createElement("div", { className: css.titleWrap },
            React.createElement(Headline, { faded: true, tag: "h1", margin: "none", className: css.title },
                React.createElement(FormattedMessage, { id: "ui-lists.missing-all-entity-type-permissions.heading" })),
            React.createElement(Headline, { faded: true, tag: "h3", margin: "none", className: css.title },
                React.createElement(FormattedMessage, { id: "ui-lists.missing-all-entity-type-permissions.message" })))));
}
